<template>
  <div class="d2-list-chart-card" ref="wordcloudPanel" :style="guideStep == 8 ? { zIndex: 100, position: 'relative' } : { position: 'relative' }">
    <loading :active="!this.showCloud"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <main class="w-full flex flex-wrap items-center gap-2 justify-between">
      <h5 class="d2-list-chart-title" style="margin-bottom:0;">{{lang['components']['List']['EventsListWordcloud']['title']}}</h5>
      <div class="flex flex-row justify-between">
        <div>
          <span v-if="viewDatalist.length > 0" class="actions-wording cursor-pointer" @click="keywordCampaign()">
            {{lang['components']['List']['EventsListWordcloud']['keyword_campaign']}}
          </span>
        </div>
      </div>
    </main>
    <canvas width="500" height="400" class="wordcloud" ref="refChart"></canvas>
    <div class="d2-kw-legend" style="justify-content:flex-end;">
      <div class="d2-kw-legend-item">
        <span class="d2-kw-legend-dot" style="background:#FFB705;"></span> {{lang['components']['List']['EventsListWordcloud']['using']}}
      </div>
      <div class="d2-kw-legend-item">
        <span class="d2-kw-legend-dot" style="background:#B9BDCD;"></span> {{lang['components']['List']['EventsListWordcloud']['no_use']}}
      </div>
    </div>
  </div>
</template>

<script>

import { ref, onMounted, onUpdated, watchEffect } from 'vue';
// import { useRoute } from 'vue-router'
import WordCloud from 'wordcloud';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import axios from 'axios'
import Qs from 'qs'

export default {
  name: 'EventsListWordcloud',
  components: {
    Loading
  },
  props: {
    guideStep: {
      type: Number,
      default: -1
    },
    showCloud: {
      type: Boolean
    },
    adaccountIdSelect: {
      type: String
    },
    viewDatalist: {
      type: Object,
      default: () => []
    },
    lang: {
      type: Object
    },
  },
  setup(props) {
    // const route = useRoute()
    const wordcloudPanel = ref();
    const refChart = ref();
    // const keywordsList = ref([
    //   { key: 'word', value: 10, isActive: true },
    //   { key: 'words', value: 8, isActive: true },
    //   { key: 'sprite', value: 7, isActive: true },
    //   { key: 'placed', value: 5, isActive: false },
    //   { key: 'layout', value: 4, isActive: true },
    //   { key: 'algorithm', value: 4, isActive: false },
    //   { key: 'area', value: 4, isActive: false },
    //   { key: 'without', value: 3, isActive: false },
    //   { key: 'step', value: 3, isActive: false },
    //   { key: 'bounding', value: 3, isActive: false },
    //   { key: 'retrieve', value: 3, isActive: true },
    //   { key: 'operation', value: 3, isActive: false },
    //   { key: 'collision', value: 3, isActive: true },
    //   { key: 'candidate', value: 3, isActive: true },
    //   { key: 'sad', value: 4, isActive: false },
    //   { key: 'hello', value: 2, isActive: false },
    //   { key: 'worlds', value: 3, isActive: true },
    //   { key: 'Apple', value: 5, isActive: true },
    //   { key: 'google', value: 5, isActive: true },
    // ]);

    const keywordsList = ref([]);

    // console.log('props');
    // console.log(props);

    const selectWord = ref('');

    var check = 0;

    const handleSelectWord = (key) => {
      selectWord.value = key;
    };

    watchEffect(() => {
      // console.log('watchEffect b keywordsList');
      // console.log(keywordsList);
      keywordsList.value = props.viewDatalist;
      // console.log('watchEffect a keywordsList');
      // console.log(keywordsList);

      // console.log('props.showCloud:'+props.showCloud);

      check = 0;//
    });

    onUpdated(() => {

      if(check == 0){
        // console.log('準備');
        // if(keywordsList.value.length > 0 && check == 0){
        if(check == 0){
          // console.log('props.showCloud:'+props.showCloud);
          const list = [];
          for (let idx = 0; idx < keywordsList.value.length; idx++) {
            list.push([
              keywordsList.value[idx].key,
              keywordsList.value[idx].value * 5
            ])
          }
          refChart.value.width = wordcloudPanel.value.getBoundingClientRect().width * 0.9;
          refChart.value.height = wordcloudPanel.value.getBoundingClientRect().height * 0.6;
          WordCloud(refChart.value, {
            list: list,
            gridSize: 1,
            // weightFactor: function (size) {
            //   return size;
            // },
            weightFactor: (size) => {
              return size;
            },
            /* eslint-disable */
            // color: function (word, weight, fontSize, distance, theta) {
            //   const checkIsActive = keywordsList.value.filter(e => e.key === word);
            //   return checkIsActive[0]?.isActive ? '#FFB705' : '#B9BDCD';
            //   // (weight > 40) ? '#f02222' : '#000';
            // },
            color: (word, weight, fontSize, distance, theta) => {
              const checkIsActive = keywordsList.value.filter(e => e.key === word);
              return checkIsActive[0]?.isActive ? '#FFB705' : '#B9BDCD';
              // (weight > 40) ? '#f02222' : '#000';
            },
            classes: () => {
              return 'hover'
            },
            rotateRatio: 0,
            rotationSteps: 2,
            maskColor: '#f02222',
            hover: (item) => {
              // console.log(item)
            },
            click: (item) => {
              // console.log('click', item[0])
              selectWord.value = item[0];
            }
          });
        }
      }
    });

    return {
      selectWord,
      wordcloudPanel,
      refChart,
      keywordsList,
      handleSelectWord
    };
  },
  methods: {
    keywordCampaign(){
      // console.log('keywordCampaign');
      // console.log('code:'+this.$route.params.id);
      // console.log('adaccountIdSelect:'+this.adaccountIdSelect);
      // console.log('keywordsList:'+this.keywordsList);
      // console.log('viewDatalistModal:'+this.viewDatalistModal);

      let keywordsList_length = this.keywordsList.length

      if(keywordsList_length > 0){
        axios
          .post('https://www.autoturn.net/api/keyword_with_campaign.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.adaccountIdSelect,
            campaign_id: this.campaignIdSelect,
            keywordsList: this.keywordsList,
            selectWord: []
          }))
          .then((reResponse) => {
            // console.log(reResponse.data);

            if(reResponse.data.status == 'success'){
              //成功
              // console.log('成功');
              window.location.href = "https://private.autoturn.net/event-add/f/"+this.$route.params.id+"/"+this.adaccountIdSelect;
            } else {
              //失敗
              Swal.fire(
                    this.lang['components']['List']['EventsListWordcloud']['keywordCampaign']['axios']['success_else']['swal_title'],
                    reResponse.data.info,
                    reResponse.data.status
                  )
            }

            // this.keywordList = reResponse.data.return_data

            // console.log(this.keywordList);
          });
      } else {
        Swal.fire(
                    this.lang['components']['List']['EventsListWordcloud']['else']['swal_title'],
                    this.lang['components']['List']['EventsListWordcloud']['else']['swal_text'],
                    'warning'
                  )
      }
    }
  }
};
</script>
<style lang="scss" scoped>

/* panel / h5 / downer-block 樣式已由 d2-list-chart-card / d2-list-chart-title 全局 CSS 取代 */

.wordcloud {
  width: 100%;
  max-width: 100%;
  height: auto;
  cursor: pointer;
}

.actions-wording {
  font-family: PingFang HK;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  text-align: right;
  text-decoration-line: underline;
  color: #72B6F4;
  cursor: pointer;

}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.report-list {
  width: 100%;
  height: 28.1vw;
  overflow: scroll;
  transition: 0.6s;
}

.table-padding {
  padding: 35px;
}

.table-col-name {
  display: flex;
  height: 24.15px;
  border-bottom: 1px solid #9B9B9B;

  .first-col {
    width: 143px;
  }

  h3 {
    font-family: PingFang HK;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
}

.table-col-value {
  display: flex;
  height: 49.58px;
  padding-top: 7.26px;
  border-bottom: 1px solid #F7F7F7;
  transition: 0.3s;

  .first-col {
    width: 143px;
  }

  p {
    font-family: PingFang HK;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 17px;
    color: #7E7E7E;
  }
}

.table-col-value:hover {
  background: #e6ffff;
  cursor: pointer;
}

.select {
  background: #EDF4FC;
  color: #6298D7 !important;
}

.hover {
  cursor: pointer;
}

/* RWD 已由 d2-list-chart-card 全局 CSS 處理 */

</style>